import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const empty = { codigo: '', descricao: '', pontos_bonus: '', dias_premium: '', data_inicio: '', data_fim: '' };

export default function AdminCupons() {
  const [cupons, setCupons] = useState([]);
  const [form, setForm] = useState(empty);
  const [editando, setEditando] = useState(null);
  const [busca, setBusca] = useState('');
  const [msg, setMsg] = useState('');

  useEffect(() => { carregar(); }, []);
  function carregar() { api.get('/cupons').then(setCupons).catch(() => {}); }

  function set(field) { return e => setForm(f => ({ ...f, [field]: e.target.value })); }

  async function salvar(e) {
    e.preventDefault(); setMsg('');
    try {
      const dados = {
        codigo: form.codigo,
        descricao: form.descricao,
        pontos_bonus: form.pontos_bonus !== '' ? Number(form.pontos_bonus) : 0,
        dias_premium: form.dias_premium !== '' ? Number(form.dias_premium) : 0,
        data_inicio: form.data_inicio || null,
        data_fim: form.data_fim || null,
      };
      if (editando) {
        dados.ativo = editando.ativo ? 1 : 0;
        await api.put(`/cupons/${editando.id}`, dados);
      } else {
        await api.post('/cupons', dados);
      }
      setMsg('Salvo com sucesso!');
      setForm(empty); setEditando(null); carregar();
    } catch (err) { setMsg(err.message); }
  }

  async function deletar(id) {
    if (!window.confirm('Remover cupom?')) return;
    try {
      await api.delete(`/cupons/${id}`);
      carregar();
    } catch (err) {
      setMsg(err.message);
    }
  }

  async function alternarAtivo(c) {
    await api.put(`/cupons/${c.id}`, {
      codigo: c.codigo, descricao: c.descricao, pontos_bonus: c.pontos_bonus, dias_premium: c.dias_premium,
      data_inicio: c.data_inicio, data_fim: c.data_fim, ativo: c.ativo ? 0 : 1,
    });
    carregar();
  }

  function iniciarEdicao(c) {
    setEditando(c);
    setForm({
      codigo: c.codigo,
      descricao: c.descricao || '',
      pontos_bonus: c.pontos_bonus,
      dias_premium: c.dias_premium,
      data_inicio: c.data_inicio ? c.data_inicio.slice(0, 10) : '',
      data_fim: c.data_fim ? c.data_fim.slice(0, 10) : '',
    });
  }

  function cancelar() {
    setEditando(null);
    setForm(empty);
  }

  const filtrados = cupons.filter(c =>
    !busca.trim() || c.codigo.toLowerCase().includes(busca.trim().toLowerCase()) ||
    (c.descricao || '').toLowerCase().includes(busca.trim().toLowerCase())
  );

  const totais = cupons.reduce((acc, c) => ({
    usos: acc.usos + Number(c.usos),
    pontos: acc.pontos + Number(c.total_pontos_distribuidos),
    dias: acc.dias + Number(c.total_dias_premium_distribuidos),
  }), { usos: 0, pontos: 0, dias: 0 });

  return (
    <div>
      <h2 className="admin-title">Cupons</h2>
      {msg && <div className="alert alert-success">{msg}</div>}

      <div className="form-row" style={{ marginBottom: 20 }}>
        <div className="card" style={{ flex: 1, padding: 14, textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 800 }}>{totais.usos}</div>
          <div style={{ fontSize: 11, color: 'var(--text2)' }}>Utilizações</div>
        </div>
        <div className="card" style={{ flex: 1, padding: 14, textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 800 }}>{totais.pontos}</div>
          <div style={{ fontSize: 11, color: 'var(--text2)' }}>Pontos distribuídos</div>
        </div>
        <div className="card" style={{ flex: 1, padding: 14, textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 800 }}>{totais.dias}</div>
          <div style={{ fontSize: 11, color: 'var(--text2)' }}>Dias Premium concedidos</div>
        </div>
      </div>

      <form onSubmit={salvar} className="admin-form">
        <h3>{editando ? `Editar Cupom: ${editando.codigo}` : 'Novo Cupom'}</h3>
        <div className="form-row">
          <div className="form-group"><label>Código</label><input value={form.codigo} onChange={set('codigo')} required placeholder="EX: BEMVINDO10" /></div>
          <div className="form-group"><label>Descrição</label><input value={form.descricao} onChange={set('descricao')} placeholder="Opcional" /></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>Pontos Bônus</label><input type="number" min="0" value={form.pontos_bonus} onChange={set('pontos_bonus')} /></div>
          <div className="form-group"><label>Dias Premium</label><input type="number" min="0" value={form.dias_premium} onChange={set('dias_premium')} /></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>Data Início (opcional)</label><input type="date" value={form.data_inicio} onChange={set('data_inicio')} /></div>
          <div className="form-group"><label>Data Fim (opcional)</label><input type="date" value={form.data_fim} onChange={set('data_fim')} /></div>
        </div>
        <div className="admin-actions">
          <button type="submit" className="btn btn-primary">Salvar</button>
          {editando && <button type="button" className="btn btn-secondary" onClick={cancelar}>Cancelar</button>}
        </div>
      </form>

      <div className="form-group" style={{ maxWidth: 300 }}>
        <label>Pesquisar</label>
        <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Código ou descrição" />
      </div>

      <div className="admin-table-wrap">
        <table>
          <thead>
            <tr><th>Código</th><th>Benefícios</th><th>Período</th><th>Usos</th><th>Ativo</th><th>Ações</th></tr>
          </thead>
          <tbody>
            {filtrados.map(c => (
              <tr key={c.id}>
                <td><b>{c.codigo}</b>{c.descricao && <div style={{ fontSize: 11, color: 'var(--text2)' }}>{c.descricao}</div>}</td>
                <td style={{ fontSize: 12 }}>⭐ {c.pontos_bonus} pts · 👑 {c.dias_premium} dias</td>
                <td style={{ fontSize: 12, color: 'var(--text2)' }}>
                  {c.data_inicio ? c.data_inicio.slice(0, 10) : '—'} até {c.data_fim ? c.data_fim.slice(0, 10) : '—'}
                </td>
                <td style={{ fontSize: 12 }}>{c.usos}</td>
                <td>{c.ativo ? <span className="badge badge-success">Sim</span> : <span className="badge badge-danger">Não</span>}</td>
                <td>
                  <div className="admin-actions">
                    <button className="btn btn-secondary" onClick={() => iniciarEdicao(c)}>Editar</button>
                    <button className={c.ativo ? 'btn btn-danger' : 'btn btn-success'} onClick={() => alternarAtivo(c)}>
                      {c.ativo ? 'Inativar' : 'Ativar'}
                    </button>
                    <button className="btn btn-danger" onClick={() => deletar(c.id)}>Remover</button>
                  </div>
                </td>
              </tr>
            ))}
            {filtrados.length === 0 && (
              <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--text2)', padding: 20 }}>Nenhum cupom encontrado.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
